/*

  PROBLEM $.cookie IS A PLUGIN?

  Changes:
  $.cookie(a) --> Cookies.get(a)
  $.cookie(a,b,c) --> Cookies.set(a,b,c)
  $.removeCookie(a) --> Cookies.remove(a)

*/

const Cookies = require("js-cookie");

let cookieBite = {};

cookieBite.settings = {
  hashSalt: 510364800,
  cookieName: 'ok-cookiebite',
  sessionExpiryTime: 30, // expressed in minutes
  debugMode: false // display log messages if true
};


/**
 * returns an ID based on the current UTC date
 *
 * @return     {string}  The daily id.
 */
cookieBite.getDailyID = function () {
  var currentDate = new Date();
  return currentDate.getUTCFullYear().toString()
    + cookieBite.padLeft(currentDate.getUTCMonth(), 2)
    + cookieBite.padLeft(currentDate.getUTCDay(), 2);
};

/**
 * Returns a new expiration time based on session expiration setting
 *
 * @return     {number}  The expiration time in miliseconds.
 */
cookieBite.getExpiryTime = function () {
  var expiryTime = Date.now() + (cookieBite.settings.sessionExpiryTime * 60 * 1000);
  cookieBite.logMessage('Expiration time: ' + expiryTime);
  return expiryTime;
};


/**
 * Generates an "unique" fingerprint to identify the user
 *
 * @return     {string}  The fingerprint.
 */
cookieBite.getFingerprint = function () {
  var nav = window.navigator;
  var screen = window.screen;
  var fingerprint = nav.mimeTypes.length;
  fingerprint += nav.userAgent.replace(/\D+/g, '');
  fingerprint += nav.plugins.length;
  fingerprint += nav.hardwareConcurrency || '';
  fingerprint += screen.height || '';
  fingerprint += screen.width || '';
  fingerprint += screen.pixelDepth || '';

  return fingerprint;
};


/**
 * Process the cookie data and returns the stored info as an object
 *
 * @return     {object}  The session data.
 */
cookieBite.getSessionData = function () {
  // var rawData = $.cookie(cookieBite.settings.cookieName).split('-');
  var rawData = Cookies.get(cookieBite.settings.cookieName).split('-');
  var processedData = {
    id: rawData[0] || 0,
    dailyId: parseInt(rawData[1]) || 0,
    session: parseInt(rawData[2]) || 0,
    expiration: new Date(parseInt(rawData[3]))
  };
  cookieBite.logMessage('Session data:', processedData);
  return processedData;
};


/**
 * Generates a hash
 *
 * @param      {string}  string  The string
 * @param      {number}  seed    The hash salt
 * @return     {number}  The string hash.
 */
cookieBite.getStringHash = function (string, seed) {
  var hash = seed || 5381;
  var i = string.length;
  while (i) {
    hash = (hash * 33) ^ string.charCodeAt(--i);
  }
  return hash >>> 0;
};


/**
 * Generate an userID hash based on the user fingerprint
 *
 * @return     {string}  The user ID hash
 */
cookieBite.getUserID = function () {
  var userID = cookieBite.getStringHash(cookieBite.getFingerprint(), cookieBite.settings.hashSalt);
  cookieBite.logMessage('Generated User ID: ' + userID);
  return userID;
};


/**
 * Initializes session tracking for the first time (or first time in day)
 */
cookieBite.initialize = function () {
  var sessionData = {
    id: cookieBite.getUserID(),
    dailyId: cookieBite.getDailyID(),
    session: 1,
    expiration: cookieBite.getExpiryTime()
  };
  cookieBite.setCookie(sessionData);
};


/**
 * Logs debug messasges when debugMode in settings is true
 *
 * @param      {string}  message  The log message
 * @param      {object}  data     Additional structured data
 */
cookieBite.logMessage = function (message, data) {
  if (cookieBite.settings.debugMode) {
    // eslint-disable-next-line no-console
    console.log(
      ' %cCOOKIEBITE%c ' + message,
      'background-color: #A0522D; color: white;',
      'background-color: white; color: #A0522D;',
      (data) ? data : ''
    );
  }
};


/**
 * Retuns an string padded to the left with 0 or passed character
 *
 * @param      {number}  val        The value
 * @param      {number}  quantity   The quantity
 * @param      {string}  character  The character
 * @return     {string}  the padded string
 */
cookieBite.padLeft = function (val, quantity, character) {
  return Array(quantity - String(val).length + 1).join(character || '0') + val;
};


/**
 * Performs the session update operation
 *
 * @param      {object}  sessionData  The session data
 */
cookieBite.renewSession = function (sessionData) {
  var session = sessionData || cookieBite.getSessionData();
  session.session = session.session + 1;
  session.expiration = cookieBite.getExpiryTime();
  cookieBite.setCookie(session);
  cookieBite.logMessage('Session renewed...');
};


/**
 * Process session data and sets the cookie.
 *
 * @param      {object}  sessionData  The session data
 */
cookieBite.setCookie = function (sessionData) {
  var cookieValue = sessionData.id
    + '-' + sessionData.dailyId
    + '-' + cookieBite.padLeft(sessionData.session, 6)
    + '-' + sessionData.expiration;
  // $.cookie(cookieBite.settings.cookieName, cookieValue, {path: '/', expires: 365, secure: true});
  Cookies.set(cookieBite.settings.cookieName, cookieValue, {path: '/', expires: 365, secure: true});
  cookieBite.logMessage('Cookie created/updated with values: ', sessionData);
};


/**
 * Performs the cookie expiration time update
 *
 * @param      {object}  sessionData  The session data
 */
cookieBite.updateExpirationTime = function (sessionData) {
  var session = sessionData || cookieBite.getSessionData();
  session.expiration = cookieBite.getExpiryTime();
  cookieBite.setCookie(session);
  cookieBite.logMessage('Session time updated...');
};


// Outputs the configuration settings
cookieBite.logMessage('Settings:', cookieBite.settings);

// Check if cookie already exists or create it
// if (typeof $.cookie(cookieBite.settings.cookieName) === 'undefined') {
if (typeof Cookies.get(cookieBite.settings.cookieName) === 'undefined') {
  cookieBite.initialize();
}
else {
  var currentDate = new Date();
  var sessionData = cookieBite.getSessionData();
  var timeDiff = sessionData.expiration.getTime() - currentDate.getTime();

  // Check if session is from a previous day
  if (sessionData.expiration.toDateString() !== currentDate.toDateString()) {
    // $.removeCookie(cookieBite.settings.cookieName);
    Cookies.remove(cookieBite.settings.cookieName);
    cookieBite.initialize();
    cookieBite.logMessage('Session expired by end of day...');

  } else {  // If session isn't valid anymore renew it, otherwhise update expiration tyme
    if (timeDiff < 0) {
      cookieBite.logMessage('Session expired, creating new session...');
      cookieBite.renewSession(sessionData);

    } else {
      cookieBite.logMessage('Session still alive ('
        + Math.round((timeDiff / 1000 / 60) * 100) / 100
        + ' minutes left), reseting expiration time...');
      cookieBite.updateExpirationTime(sessionData);
    }
  }
}
window.cookieBite = cookieBite;
